import {
  EMPLOYMENT_EARNING_ADD_NEW,
  EMPLOYMENT_EARNING_ADD_NEW_SUCCESS,
  EMPLOYMENT_EARNING_ADD_NEW_ERROR,
  EMPLOYMENT_EARNING_DELETE,
  EMPLOYMENT_EARNING_DELETE_ERROR,
  EMPLOYMENT_EARNING_DELETE_SUCCESS,
  EMPLOYMENT_EARNING_EDIT,
  EMPLOYMENT_EARNING_EDIT_ERROR,
  EMPLOYMENT_EARNING_EDIT_SUCCESS,
  EMPLOYMENT_EARNING_GET_BY_ID,
  EMPLOYMENT_EARNING_GET_BY_ID_ERROR,
  EMPLOYMENT_EARNING_GET_BY_ID_SUCCESS,
  EMPLOYMENT_EARNING_GET_LIST,
  EMPLOYMENT_EARNING_GET_LIST_ERROR,
  EMPLOYMENT_EARNING_GET_LIST_SUCCESS,
  EMPLOYMENT_EARNING_ADD_NEW_REQUEST,
  EMPLOYMENT_EARNING_QUERY,
  EMPLOYMENT_EARNING_QUERY_SUCCESS,
  EMPLOYMENT_EARNING_QUERY_ERROR,
} from '../actions';

const initialState = {
  employmentEarnings: [],
  employmentEarning: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case EMPLOYMENT_EARNING_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case EMPLOYMENT_EARNING_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        employmentEarning: payload,
      };

    case EMPLOYMENT_EARNING_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case EMPLOYMENT_EARNING_QUERY:
    case EMPLOYMENT_EARNING_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case EMPLOYMENT_EARNING_QUERY_SUCCESS:
    case EMPLOYMENT_EARNING_GET_LIST_SUCCESS:
      return {
        ...state,
        employmentEarnings: payload,
        loading: true,
      };
    case EMPLOYMENT_EARNING_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case EMPLOYMENT_EARNING_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        employmentEarning: payload,
        employmentEarnings: state.employmentEarnings.concat(payload),
        addSuccess: true,
      };

    case EMPLOYMENT_EARNING_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case EMPLOYMENT_EARNING_EDIT_SUCCESS:
      return {
        ...state,
        loading: true,
        employmentEarnings: state.employmentEarnings.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        employmentEarning: payload,
        error: null,
        editSuccess: true,
      };
    case EMPLOYMENT_EARNING_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case EMPLOYMENT_EARNING_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        employmentEarnings: state.employmentEarnings.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case EMPLOYMENT_EARNING_QUERY_ERROR:
    case EMPLOYMENT_EARNING_DELETE_ERROR:
    case EMPLOYMENT_EARNING_ADD_NEW_ERROR:
    case EMPLOYMENT_EARNING_EDIT_ERROR:
    case EMPLOYMENT_EARNING_GET_BY_ID_ERROR:
    case EMPLOYMENT_EARNING_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
